import { css } from 'styled-components';
import { ColorAddiPrimaryActive, ColorAddiPrimaryHover, ColorAddiPrimaryInactive, ColorAddiGrayLighten3, ColorAddiFontOverDark } from "@addi/foundation/dist/web/colors";
export const PrimaryButtonStyles = css `
    border: none;
    color: ${ColorAddiFontOverDark};
    background-color: ${ColorAddiPrimaryActive};

    &:hover {
        background-color: ${ColorAddiPrimaryHover};
    }

    &:active {
        background-color: ${ColorAddiPrimaryActive};
    }

    &:focus {
        border: 2px solid ${ColorAddiGrayLighten3};
        background-color: ${ColorAddiPrimaryHover};
    }

    &[disabled] {
        cursor: default;
        pointer-events: none;
        background-color: ${ColorAddiPrimaryInactive};
    }
`;
//# sourceMappingURL=primary-button-styles.js.map